import React from 'react';

interface ButtonProps {
  text: string;
  onClick?: () => void;
  className?: string;
}

export const Button: React.FC<ButtonProps> = ({ text, onClick, className }) => {
  return (
    <button
      className={`min-w-buttonWidth min-h-buttonHeight bg-primary text-black font-semibold hover:bg-white transition-all duration-300 ${className}`}
      onClick={onClick}
    >
      {text}
    </button>
  );
};
